import { render, staticRenderFns } from "./ShareTest.vue?vue&type=template&id=165b2a22"
import script from "./ShareTest.vue?vue&type=script&lang=js"
export * from "./ShareTest.vue?vue&type=script&lang=js"
import style0 from "./ShareTest.vue?vue&type=style&index=0&id=165b2a22&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports